import React from "react";

import AxisSelectionTableRowSection from "./AxisSelectionTableRowSection";

const AxisSelectionTableRowsSection = ({
  products, // This an object with keys as axisGCR
  productLength,
  technicalFeatureLength,
  performanceOverviewLength,
  guidingSystemLength,
  mechanics,
  selectedAxis,
  axesToCompare,
  axisSelection,
  steps,
  productTableHeaders,
  technicalFeaturesTableHeaders,
  performanceOverviewTableHeaders,
  getGuidingSystemTableHeaders,
  setCartesianCurrentStep,
  setAxisOptions,
  setAxisSelection,
  addAxisToCompare,
  ...props
}) => {
  const content = [];
  // Iterate over each group of products
  Object.keys(products).forEach((axisGCR) => {
    const productItems = products[axisGCR]; // Array of products for this axisGCR
    productItems.forEach((product, index) => {
      content.push(
        <AxisSelectionTableRowSection
          data-testid={`axis-selection-table-row-section-${product.id}`}
          key={product.id} // Use a unique key for each row
          isTopRow={index === 0}
          isBorder={index === productItems.length - 1}
          rowSpan={productItems.length}
          product={product.axis.axisModel} // Use axisGCR as the product name
          data={product} // Pass the entire product as data
          productLength={productLength}
          technicalFeatureLength={technicalFeatureLength}
          performanceOverviewLength={performanceOverviewLength}
          guidingSystemLength={guidingSystemLength}
          selected={selectedAxis?.id === product.id}
          mechanics={mechanics}
          axesToCompare={axesToCompare}
          axisSelection={axisSelection}
          steps={steps}
          productTableHeaders={productTableHeaders}
          technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
          performanceOverviewTableHeaders={performanceOverviewTableHeaders}
          getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
          setCartesianCurrentStep={setCartesianCurrentStep}
          setAxisOptions={setAxisOptions}
          setAxisSelection={setAxisSelection}
          addAxisToCompare={addAxisToCompare}
        />
      );
    });
  });

  return content;
};

export default AxisSelectionTableRowsSection;
